import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { ADYEN_BRAND_ONBOARDING_COUNTRIES } from "@faire/web-api--source/indigofair/settings/ADYEN_BRAND_ONBOARDING_COUNTRIES";

export function getSettingAdyenEligibleCountries(): string[] {
  return getSettingValueWithoutAssignment(ADYEN_BRAND_ONBOARDING_COUNTRIES, []);
}
